import {PowellConfig} from "@models";

export const powellDefaults: PowellConfig = {
  theme: 'lara-light-cyan',
  rtl: false,
  showRequiredStar: true,
  ripple: true,
  inputSize: 'medium',
  inputStyle: 'outlined',
  labelPosition: 'top',
  fixLabelPosition: 'side',
  injectDirectionToRoot: false,
}
